import {
  noteConverter,
  createNoteConverter,
  updateNoteConverter,
} from 'data/convertors/notes.convertors';
import {
  TNoteDB,
  TNoteUI,
  TCreateNoteUI,
  TUpdateNoteUI,
  TDeleteNoteUI,
  TGetNotesParams,
} from 'data/types/notes.types';
import { ENotesUrls } from 'data/urls/notes.url';
import { authSplitApi } from 'redux/helpers/slice.helpers';

const baseUrl = `${ENotesUrls.NOTES}`;

export const notesApi = authSplitApi('notes', ['notes']).injectEndpoints({
  endpoints: build => ({
    getNotes: build.query<TNoteUI[], TGetNotesParams>({
      query({ entityType, entityId }) {
        return {
          url: `${baseUrl}/${entityType}/${entityId}`,
          method: 'GET',
        };
      },
      providesTags: (result, error, { entityType, entityId }) => [
        { type: 'notes', id: `${entityType}-${entityId}` },
      ],
      transformResponse: (data: TNoteDB[]) => {
        return data?.length ? data.map(item => noteConverter.fromDb(item)) : [];
      },
    }),
    createNote: build.mutation<void, TCreateNoteUI>({
      query(body) {
        return {
          url: `${baseUrl}`,
          method: 'POST',
          body: createNoteConverter.toDb(body),
        };
      },
      invalidatesTags: (result, error, { entityType, id }) => [
        { type: 'notes', id: `${entityType}-${id}` },
      ],
    }),
    updateNote: build.mutation<void, TUpdateNoteUI>({
      query(body) {
        return {
          url: `${baseUrl}/${body.resourceId}`,
          method: 'PATCH',
          body: updateNoteConverter.toDb(body),
        };
      },
      invalidatesTags: ['notes'],
    }),
    deleteNote: build.mutation<void, TDeleteNoteUI>({
      query({ resourceId }) {
        return {
          url: `${baseUrl}/${resourceId}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['notes'],
    }),
  }),
});

export const {
  useGetNotesQuery,
  useCreateNoteMutation,
  useUpdateNoteMutation,
  useDeleteNoteMutation,
} = notesApi;
